(function () {
  'use strict';
  var engine = window.BlusafeCompatibility;
  if (!engine || engine.auInstallation) return;
  var originalEvaluate = engine.evaluate;
  engine.auInstallation = true;

  function result(status, reason) {
    return { status: status, reasons: [reason], recommendedProducts: [], rejectedProducts: [], missingChecks: [], warnings: [], accessoryRecommendations: [] };
  }

  engine.evaluate = function (input) {
    input = input || {};
    var answers = input.answers || {};
    var rules = input.rules || engine.getRules() || {};
    if (rules.market !== 'au') return originalEvaluate(input);
    var handle = input.productHandle || '';
    var family = answers.currentFamily || engine.inferFamilyFromHandle(handle, input.products);
    var isHandle = family === 'apollo' || family === 'osp_legacy';
    var isMain = input.mode !== 'mini';
    var timber = ['timber_latch', 'external_latch', 'internal_latch'].indexOf(answers.lockType) !== -1;

    if (/breeze|axis|synthara|yunity/i.test(handle) || (isMain && ['euro_cylinder', 'slam_shut_multipoint'].indexOf(answers.lockType) !== -1)) {
      return result('photo_required', 'This product is not in the Australian range. Contact us to check another option for your door.');
    }

    if (timber && (isMain || isHandle)) {
      if (answers.au_wooden_door !== 'yes') {
        return result('photo_required', 'This installation route is for a wooden door with a latch. Send photos if your door uses a different setup.');
      }
      if (answers.au_door_thickness === '30_or_less') {
        return result('not_compatible', 'The included-lock-body installation for Apollo and Origin Smart Plus needs a wooden door over 30 mm thick. A door exactly 30 mm thick does not meet this requirement.');
      }
      if (answers.au_door_thickness !== 'over_30') {
        return result('photo_required', 'Measure the door thickness before choosing Apollo or Origin Smart Plus: it must be over 30 mm for the included-lock-body installation.');
      }
      var matched = result('compatible', 'Apollo and both Origin Smart Plus versions fit wooden doors over 30 mm thick using the lock body included with the Australian package.');
      matched.warnings.push('Fit the supplied lock body into the door; this is not a straight swap of the existing latch.');
      if (isMain) matched.warnings.push('Contour and Cloud are also in the wooden-door category; check their own latch or deadbolt preparation and measurements.');
      matched.recommendedProducts = (input.products || []).filter(function (product) {
        return product.handle && (isMain ? ['apollo', 'osp_legacy'].indexOf(product.family) !== -1 : product.handle === handle);
      });
      if (!isMain) {
        matched.recommendedProducts = matched.recommendedProducts.map(function (product) {
          return Object.assign({}, product, {family: 'au_timber'});
        });
      }
      if (answers.remote_control === 'yes') {
        matched.accessoryRecommendations.push({type: 'gateway', title: 'TTLock Wi-Fi bridge', reason: 'Required for remote access away from the door; included only where your chosen bundle says so.'});
      }
      return matched;
    }

    var nativeInput = Object.assign({}, input, {
      products: (input.products || []).filter(function (product) { return product.handle && !/breeze|axis|synthara|yunity/i.test(product.handle); }),
      rules: Object.assign({}, rules, {lockTypeFamilyMap: Object.assign({}, rules.lockTypeFamilyMap, {external_latch: 'contour', internal_latch: 'breeze'})})
    });
    var nativeResult = originalEvaluate(nativeInput);
    return nativeResult;
  };
})();
